import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import MenuItem from "@mui/material/MenuItem";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import edit from "../../../../Assets/edit.svg";
import del from "../../../../Assets/Box.svg";

import ExcelIcon from "../../../../Assets/ExcelIcon.svg";
import "../button.css";
import { io } from "socket.io-client";

const socket = io('https://policydekhoo-backend.onrender.com');


const PersonalInsurance = ({exportToExcel,setData}) => {
  const data=JSON.parse(localStorage.getItem("userData")).Permissions
  const [permissionsList,setpermissionsList]=useState([])
  
  // const top100Films = [
  //   { label: "The Shawshank Redemption", year: 1994 },
  //   { label: "The Godfather", year: 1972 },
  //   { label: "The Godfather: Part II", year: 1974 },
  //   { label: "The Dark Knight", year: 2008 },
  //   { label: "12 Angry Men", year: 1957 },
  //   { label: "Schindler's List", year: 1993 },
  //   { label: "Pulp Fiction", year: 1994 },
  // ];


  useEffect(() => {
    if(data!==null)
      {
    setpermissionsList(data.split(","))
      }
 
    socket.on('dataUpdatedPersonalInsurance1', (updatedData) => {
      setData(updatedData)
        setPersonalAccidentInsurancedata(updatedData);
    });  
    socket.on('deleteDataPersonalInsurance1', (Data) => {
        setData(Data)
        setPersonalAccidentInsurancedata(Data);
    });
    return () => {
        socket.disconnect();
    };
}, []);

  const currencies = ["value1", "value2", "value3"];

  const rowsPerPageOptions = [5, 10, 25]; // Rows per page options

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  function Row(props) {
    const { row } = props;
    const [open, setOpen] = React.useState(false);
    const [editcheck, seteditcheck] = React.useState(false);
    const [idselected, setidselected] = useState();

    const editdata = (e) => {
      // console.log(e);
      seteditcheck(false);
    };

    const [tableName, settablename] = useState("personal_accident");

    const handleDelete = async (id) => {
      try {
        // Store the ID of the row when delete button is clicked
        setidselected(id);
        // console.log("Id to be deleted is : =======", id);

        // Construct the URL with the tableName and idselected
        const url = `https://policydekhoo-backend.onrender.com/Removedata?tableName=${tableName}&id=${id}`;

        // Make a DELETE request to the URL
        const response = await fetch(url, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        });

        // Check if the request was successful
        if (!response.ok) {
          throw new Error("Failed to delete data");
        }

        // Optionally, you can handle the response here
        const responseData = await response.json();
        const temp=[...PersonalAccidentInsurancedata]
        let ind=""
        temp.map((val,index)=>{
          if(val.id===id){
            ind=index;
            console.log(val,index)
          }
        })
        temp.splice(ind,1);
        console.log(temp,"jaiiii");
        console.log("Delete response:", responseData);
        setPersonalAccidentInsurancedata(temp)
        setData(temp)
      socket.emit('deleteDataPersonalInsurance', temp);


        // Refresh the data after deletion
        // Call the function that fetches data again
        // getCarInsurancedata();
      } catch (error) {
        console.error("Error deleting data:", error);
      }
    };

    const addvalues = (e) => {
      setdata2({ ...data2, [e.target.name]: e.target.value });
    };

    const [data2, setdata2] = useState({});

    console.log("data2", data2);

    const UpdatePersonalInsurance = async (id) => {
      // setidselected(id);
      // console.log("Id to be updated is : =======", id);
      // e.preventDefault();

      try {
        // setidselected(id); // Set the ID first
        console.log(
          "===============data to be updated and id",
          data2,
          id,
          tableName
        );
        const response = await fetch(
          `https://policydekhoo-backend.onrender.com/Updatedata?tableName=${tableName}&id=${id}`,
          {
            method: "PATCH",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data2),
          }
        );

        if (response.ok) {
          const temp=[...PersonalAccidentInsurancedata]
          let ind=""
          temp.map((val,index)=>{
            if(val.id===id)
              {
                ind=index
              }
          })
          const temp1={...temp[ind]}
          console.log(temp1,"[][][][][][[[[")    
          Object.keys(data2).map((k1)=>(
            temp1[k1]=data2[k1]
          )) 
          temp[ind]=(temp1);
          setPersonalAccidentInsurancedata(temp) 
          setData(temp)
        socket.emit('editDataPersonalInsurance', temp);

          console.log("Data updated successfully");
        } else {
          console.error("Failed to update data");
        }
      } catch (error) {
        console.error("Error:", error);
      }
      editdata();
    };

    useEffect(() => {
      // console.log("Id to be deleted is : =======", idselected);
    }, [idselected]);
    return (
      <React.Fragment>
        <TableRow>
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>

          {row.map((val, index) =>
            index <= 2 ? (
              editcheck ? (
                <TableCell align="left">
                  <TextField
                    id="outlined-size-small"
                    defaultValue={val}
                    size="small"
                  />
                </TableCell>
              ) : (
                <TableCell align="left">{val}</TableCell>
              )
            ) : (
              ""
            )
          )}
          <TableCell align="left">
            {row[3] === "pending" ? (
              <label
                className="p-1 px-2 mx-1 rounded  pendng-bg"
                htmlFor="pending"
              >
                <b> Pending</b>
              </label>
            ) : (
              ""
            )}
            <label
              className={`p-1 px-2 mx-1 rounded ${
                row[3] === "accepted" ? "accepted-bg" : "border-accepted"
              }   `}
              htmlFor="Accepted"
            >
              <b>Accepted</b>
            </label>
            <label
              className={`p-1 px-2 mx-1 rounded ${
                row[3] === "denied" ? " denied-bg" : "border-denied"
              }`}
              htmlFor="Denied"
            >
              <b>Denied</b>
            </label>
          </TableCell>
          { permissionsList.includes("edit")||permissionsList.includes("delete")?
          <TableCell
            className="text-left"
            sx={{ minWidth: 100, whiteSpace: "nowrap" }}
          >
            { permissionsList.includes("edit")?
            <label className="me-1">
              <img
                src={edit}
                alt=""
                onClick={() => {
                  seteditcheck(true);
                }}
              />
            </label>:""}
            { permissionsList.includes("delete")?
            <label className="me-1">
              <img src={del} alt="" onClick={() => handleDelete(row[0])} />
            </label>:""}
          </TableCell>
          :""}
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                {/* <Typography variant="h6" gutterBottom component="div">
                  History
                </Typography> */}
                <Table size="medium" aria-label="purchases">
                  <TableBody className="text-left">
                    <TableRow>
                      {editcheck ? (
                        <TableCell align="left">
                          <b>Gender - </b>
                          <TextField
                            id="outlined-size-small"
                            defaultValue={row[4].gender}
                            size="small"
                            value={data2.Self_Gender}
                            onChange={addvalues}
                            name="Self_Gender"
                          />
                        </TableCell>
                      ) : (
                        <TableCell>
                          <b>Gender - </b>
                          {row[4].gender}
                        </TableCell>
                      )}
                      {editcheck ? (
                        <TableCell align="left">
                          <b>Self Occupation - </b>
                          <TextField
                            id="outlined-size-small"
                            defaultValue={row[4].selfOccupation}
                            size="small"
                            value={data2.Self_Occupation}
                            onChange={addvalues}
                            name="Self_Occupation"
                          />
                        </TableCell>
                      ) : (
                        <TableCell>
                          <b>Self Occupation - </b>
                          {row[4].selfOccupation}
                        </TableCell>
                      )}
                      {editcheck ? (
                        <TableCell align="left">
                          <b>Spouse Occupation - </b>
                          <TextField
                            id="outlined-size-small"
                            defaultValue={row[4].spouseOccupation}
                            size="small"
                            value={data2.Spouse_Occupation}
                            onChange={addvalues}
                            name="Spouse_Occupation"
                          />
                        </TableCell>
                      ) : (
                        <TableCell>
                          <b>Spouse Occupation - </b>
                          {row[4].spouseOccupation}
                        </TableCell>
                      )}

                      {editcheck ? (
                        <TableCell align="left">
                          <b>Annual Income - </b>
                          <TextField
                            id="outlined-size-small"
                            defaultValue={row[4].annualIncome}
                            size="small"
                            value={data2.Annual_Income}
                            onChange={addvalues}
                            name="Annual_Income"
                          />
                        </TableCell>
                      ) : (
                        <TableCell>
                          <b>Annual Income - </b>
                          {row[4].annualIncome}
                        </TableCell>
                      )}
                    </TableRow>
                    <TableRow>
                      {editcheck ? (
                        <TableCell align="left">
                          <b>Pincode - </b>
                          <TextField
                            id="outlined-size-small"
                            defaultValue={row[4].pincode}
                            size="small"
                            value={data2.Pincode}
                            onChange={addvalues}
                            name="Pincode"
                          />
                        </TableCell>
                      ) : (
                        <TableCell>
                          <b>Pincode - </b>
                          {row[4].pincode}
                        </TableCell>
                      )}
                      {editcheck ? (
                        <TableCell align="left">
                          <b>Self DOB - </b>
                          <TextField
                            id="outlined-size-small"
                            defaultValue={row[4].SelfDOB}
                            size="small"
                            value={data2.Self_DOB}
                            onChange={addvalues}
                            name="Self_DOB"
                          />
                        </TableCell>
                      ) : (
                        <TableCell>
                          <b>Self DOB - </b>
                          {row[4].SelfDOB}
                        </TableCell>
                      )}

                      {editcheck ? (
                        <TableCell align="left">
                          <b>Spouse DOB - </b>
                          <TextField
                            id="outlined-size-small"
                            defaultValue={row[4].SpouseDOB}
                            size="small"
                            value={data2.Spouse_DOB}
                            onChange={addvalues}
                            name="Spouse_DOB"
                          />
                        </TableCell>
                      ) : (
                        <TableCell>
                          <b>Spouse DOB - </b>
                          {row[4].SpouseDOB}
                        </TableCell>
                      )}

                      {editcheck ? (
                        <TableCell align="left">
                          <b>Any Member With Medical Condition - </b>
                          <TextField
                            id="outlined-size-small"
                            defaultValue={row[4].medicalConditionMember}
                            size="small"
                            value={data2.Medical_Condition}
                            onChange={addvalues}
                            name="Medical_Condition"
                          />
                        </TableCell>
                      ) : (
                        <TableCell>
                          <b>Any Member With Medical Condition - </b>
                          {row[4].medicalConditionMember}
                        </TableCell>
                      )}
                    </TableRow>
                    <TableRow>
                      {editcheck ? (
                        <TableCell align="left">
                          <b>Name - </b>
                          <TextField
                            id="outlined-size-small"
                            defaultValue={row[4].name}
                            size="small"
                            value={data2.Your_Name}
                            onChange={addvalues}
                            name="Your_Name"
                          />
                        </TableCell>
                      ) : (
                        <TableCell>
                          <b>Name - </b>
                          {row[4].name}
                        </TableCell>
                      )}
                      {editcheck ? (
                        <TableCell align="left">
                          <b>Mobile No - </b>
                          <TextField
                            id="outlined-size-small"
                            defaultValue={row[4].mobileNo}
                            size="small"
                            value={data2.Mobile_No}
                            onChange={addvalues}
                            name="Mobile_No"
                          />
                        </TableCell>
                      ) : (
                        <TableCell>
                          <b>Mobile No - </b>
                          {row[4].mobileNo}
                        </TableCell>
                      )}
                      {editcheck ? (
                        <TableCell>
                          <button
                            className="mt-4 accepted-bg px-3 p-1 rounded border-0 "
                            onClick={() => {
                              UpdatePersonalInsurance(row[0]);
                            }}
                          >
                            save
                          </button>
                        </TableCell>
                      ) : (
                        <TableCell></TableCell>
                      )}
                    </TableRow>
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  const [PersonalAccidentInsurancedata, setPersonalAccidentInsurancedata] =
    useState([
      // {
      //   id: 1,
      //   Self_Gender: "Male",
      //   Self_Occupation: "Salaried",
      //   Spouse_Occupation: "Salaried",
      //   Annual_Income: "12312",
      //   Pincode: "305001",
      //   Self_DOB: "2020-04-20T18:30:00.000Z",
      //   Spouse_DOB: "2020-04-20T18:30:00.000Z",
      //   Medical_Condition: "Yes",
      //   Your_Name: "Yash",
      //   Mobile_No: "9351923946",
      // },
      // {
      //   id: 2,
      //   Self_Gender: "Male",
      //   Self_Occupation: "Self Employed",
      //   Spouse_Occupation: "Salaried",
      //   Annual_Income: "1465465",
      //   Pincode: "302014",
      //   Self_DOB: "2020-04-27T18:30:00.000Z",
      //   Spouse_DOB: "2020-04-09T18:30:00.000Z",
      //   Medical_Condition: "No",
      //   Your_Name: "Rahul",
      //   Mobile_No: "5646546512",
      // },
      // {
      //   id: 3,
      //   Self_Gender: "Female",
      //   Self_Occupation: "Salaried",
      //   Spouse_Occupation: "Salaried",
      //   Annual_Income: "14165651",
      //   Pincode: "651465",
      //   Self_DOB: "2020-04-19T18:30:00.000Z",
      //   Spouse_DOB: "2020-04-25T18:30:00.000Z",
      //   Medical_Condition: "Yes",
      //   Your_Name: "Jai",
      //   Mobile_No: "5165151665",
      // },
      // {
      //   id: 4,
      //   Self_Gender: "Male",
      //   Self_Occupation: "Salaried",
      //   Spouse_Occupation: null,
      //   Annual_Income: "54654654",
      //   Pincode: "546546",
      //   Self_DOB: "2020-04-18T18:30:00.000Z",
      //   Spouse_DOB: null,
      //   Medical_Condition: "Yes",
      //   Your_Name: "Yahdh",
      //   Mobile_No: "1123213213",
      // },
    ]);

  const [tableName, settablename] = useState("personal_accident");

  useEffect(() => {
    const getPersonalAccidentInsurancedata = async () => {
      const url = `https://policydekhoo-backend.onrender.com/GetAllData?tableName=${tableName}`;

      try {
        const response = await fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch groups");
        }

        const data = await response.json();
        // console.log("Groups:", data);
        setPersonalAccidentInsurancedata(data);
        setData(data)
      } catch (error) {
        console.error("Error fetching groups:", error);
      }
    };

    getPersonalAccidentInsurancedata();
  }, []);
  console.log(PersonalAccidentInsurancedata,"[][][][][][]");

  const rows = PersonalAccidentInsurancedata.map((data) => [
    data.id,
    data.Your_Name,
    data.Mobile_No,
    data.status,
    {
      gender: data.Self_Gender,
      selfOccupation: data.Self_Occupation,
      spouseOccupation: data.Spouse_Occupation,
      annualIncome: data.Annual_Income,
      pincode: data.Pincode,
      SelfDOB: data.Self_DOB,
      SpouseDOB: data.Spouse_DOB,
      medicalConditionMember: data.Medical_Condition,
      name: data.Your_Name,
      mobileNo: data.Mobile_No,
    },
  ]);

  const Column = ["Unique ID", "Name", "Contact"];

  return (
    <div className="fade">
      <h3>Personal Accident</h3>
      <div className="row ">
        {/* <div className="col-12 my-sm-1 my-2 col-sm-4 col-md-3">
          <Autocomplete
            disablePortal
            id="combo-box-demo"
            // options={top100Films}
            // sx={{ width: 280 }}
            renderInput={(params) => <TextField {...params} label="Search" />}
          />
        </div> */}
        <div className="text-end mx-2">
                  
                  <img src={ExcelIcon} width={"30rem"} className="me-4" alt="excelIcon" style={{cursor:"pointer"}} onClick={exportToExcel} />
        {/* <div className="col-12 my-sm-1 my-2 col-sm-3 col-md-2 ">
          <TextField
            id="outlined-select-currency"
            select
            fullWidth
            label="Status"
            defaultValue={""}
          >
            {currencies.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField> */}
        </div>
      </div>
      <div className="row m-2">
        <Paper sx={{ overflow: "hidden" }}>
          <TableContainer sx={{ maxHeight: "60vh" }}>
            <Table aria-label="collapsible table" id="my-table">
              <TableHead>
                <TableRow>
                  <TableCell />
                  {Column.map((val, index) => (
                    <TableCell
                      className="text-left"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      <b>{val}</b>
                    </TableCell>
                  ))}
                  <TableCell sx={{ minWidth: 70 }} className="text-left">
                    <b>Status</b>
                  </TableCell>
                  { permissionsList.includes("edit")||permissionsList.includes("delete")?
                  <TableCell className="text-left">
                    <b>Actions</b>
                  </TableCell>:""}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => (
                    <Row key={row.name} row={row} />
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={rowsPerPageOptions}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </div>
    </div>
  );
};

export default PersonalInsurance;
